// @ts-nocheck


import { classesRuntime, statesRuntime } from "../../stylable-esm-runtime.js";



var _namespace_ = "SetupWidget525839026";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"SetupWidget525839026__root","row":"SetupWidget525839026__row","completedCta":"SetupWidget525839026__completedCta","card":"SetupWidget525839026__card","stepIcon":"SetupWidget525839026__stepIcon","chevron":"SetupWidget525839026__chevron","chevronDisabled":"SetupWidget525839026__chevronDisabled","inProgressLabel":"SetupWidget525839026__inProgressLabel"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-color-border-standard-primary":"--wds-color-border-standard-primary","wds-color-border-standard-secondary":"--wds-color-border-standard-secondary","wds-color-fill-standard-tertiary":"--wds-color-fill-standard-tertiary","wds-color-fill-standard-tertiary-hover":"--wds-color-fill-standard-tertiary-hover","wsr-color-D60":"--wsr-color-D60","wsr-color-D80":"--wsr-color-D80","wsr-color-B30":"--wsr-color-B30","wsr-color-B40":"--wsr-color-B40","wsr-color-B60":"--wsr-color-B60","wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-color-text-disabled":"--wds-color-text-disabled","wds-color-text-urgent":"--wds-color-text-urgent","wsr-color-D10":"--wsr-color-D10","wsr-color-D10-30":"--wsr-color-D10-30","wsr-color-O10":"--wsr-color-O10","wds-space-100":"--wds-space-100","wds-border-radius-200":"--wds-border-radius-200","wds-border-radius-400":"--wds-border-radius-400"}; 




